var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Layout"},[_c('layout-header'),_c('div',{staticClass:"contentBox"},[_vm._t("content")],2),_c('layout-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }